import MapOverlayView from './MapOverlayView';

import InfoWindow from 'ofs/google/maps/InfoWindow';


export default class InfoWindowView extends MapOverlayView {
  get tagName() {
    return 'div';
  }

  get className() {
    return 'ofs-infowindow';
  }

  get overlay() {
    return InfoWindow;
  }

  get overlayOptions() {
    return Object.assign(super.overlayOptions, {
      margin: new google.maps.Size(40, 40),
      maxHeight: 450,
      offset: new google.maps.Size(0, -50),
      closeOnMapClick: true,
      marker: this.marker,
      elem: this.$el
    });
  }

  initialize(options) {
    if (!options.marker) {
      throw new Error("A marker must be specified for InfoWindow view.");
    }
    this.marker = options.marker;
    super.initialize(options);
  }

  renderTemplate() {
    this.$el.html(this.template({
      model: this.model
    }));
  }

  render() {
    super.render(arguments);
    this.renderTemplate();

    // Display InfoWindow on map
    this.gOverlay.open(this.map, this.marker);
    return this;
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/views/geo/InfoWindowView.js
 **/